import React from 'react'

import './index.scss'

export const Footer = () => (
  <footer className="footer">
    ©<a href="https://github.com/irrationnelle">irrationnelle</a>, Built with{' '}
    <a href="https://github.com/JaeYeopHan/gatsby-starter-bee">
      Gatsby-starter-bee
    </a>
  </footer>
)
